var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: #fa5403;\n      }\n\n      .st3 {\n        fill: #fdfcfb;\n      }\n\n      .st4 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st5 {\n        fill: #fa5402;\n      }\n\n      .st6 {\n        fill: url(#linear-gradient);\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -161.05,
    y1: 37.89,
    x2: -71.05,
    y2: 137.89,
    gradientTransform: "translate(0 130) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -140.71,
    y1: 19.59,
    x2: -50.71,
    y2: 119.59,
    gradientTransform: "translate(0 130) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -142.4,
    y1: 21.11,
    x2: -52.4,
    y2: 121.11,
    gradientTransform: "translate(0 130) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -112.07,
    y1: -6.18,
    x2: -22.07,
    y2: 93.82,
    gradientTransform: "translate(0 130) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4700"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-103.92-5.87c-16,0-29,13-29,29,0,20,24.4,49.1,26.8,51.9,1.04,1.22,2.87,1.35,4.09.31.11-.1.22-.2.31-.31,2.4-2.8,26.8-31.9,26.8-51.9,0-16-13-29-29-29ZM-103.92,10.63c-6.77-1.37-13.36,3-14.74,9.76s3,13.36,9.76,14.74c1.64.33,3.33.33,4.97,0,6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5v.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-151.72,66.23l32.6-14.8c2.2-1,4.7-.6,6.5,1l8.7,7.9,8.7-7.9c1.8-1.6,4.3-2,6.5-1l32.6,14.8c2.8,1.3,2.8,5.3,0,6.6l-43.3,19.3c-2.86,1.28-6.14,1.28-9,0l-43.3-19.3c-2.8-1.3-2.8-5.3,0-6.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-155.92,78.63c0-2.2,2.3-3.7,4.3-2.8l41.1,18.4c2.3,1,3.8,3.3,3.8,5.8v14.4c0,2.4-2.5,4-4.7,3l-40.7-18.3c-2.29-1.02-3.78-3.29-3.8-5.8v-14.7ZM-147.22,86.83v6.8l20.8,9.3v-6.7s-20.8-9.4-20.8-9.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-51.92,78.63c0-2.2-2.3-3.7-4.3-2.8l-41.1,18.4c-2.29,1.02-3.78,3.29-3.8,5.8v14.4c0,2.4,2.5,4,4.7,3l40.7-18.3c2.29-1.02,3.78-3.29,3.8-5.8v-14.7ZM-60.62,86.83v6.8l-20.8,9.3v-6.7s20.8-9.4,20.8-9.4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.02,91.52l9.17-3.9c.38-.16.91-.05,1.21.17.24.18.52.59.52,1.02v18.35c0,.85-.71,1.58-1.41,1.89l-10.95,4.82-24.26,10.7c-.37.16-.89.05-1.15-.14-.23-.16-.52-.59-.52-.99v-16.83s-.06-22.3-.06-22.3c0-1.24.44-2.43,1.64-2.93l34.89-14.61,2.03-.86c.33-.14.81-.04,1.1.17.24.18.48.61.49.97l.12,3.28.27,10.45c.03,1.14-.51,1.75-1.49,2.16l-23.76,10.13c-.77.33-1.51,1.11-1.51,1.97v5c-.01.59.25,1.14.64,1.47s1.08.67,1.66.43l8.16-3.41c.96-.4,1.83-1.06,1.84-2.22v-2.61c.02-.94.45-1.8,1.38-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.2,88.25l8.46,3.51c.75.31,1.24,1.16,1.25,1.95l.02,2.51c0,.8.54,1.62,1.33,1.92l9.33,3.46c1.1.41,2.36-.55,2.36-1.69l.02-4.89c0-.77-.51-1.76-1.3-2.07-7.83-3.02-15.51-6.16-23.23-9.46-.74-.32-1.52-.83-1.52-1.78l-.02-14.31c0-.4.28-.83.51-1.02.25-.21.84-.38,1.19-.23l9.93,4.07,19.04,8.06,6.59,2.82c1.23.53,2.06,1.45,2.06,2.88v39.11c0,.4-.28.78-.49.94-.23.18-.82.29-1.11.16l-3.75-1.64-31.07-13.52c-.71-.31-1.25-1.27-1.25-2.01v-17.53c0-.76.82-1.6,1.65-1.26h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.07,53.16c-.19.3-.56.36-.82.29-.19-.05-.37-.28-.54-.54l-10.48-16.18c-1.79-2.76-3.31-5.56-4.52-8.61-.84-2.09-1.36-4.16-1.46-6.43-.19-4.32,1.23-8.59,3.92-11.96,3.48-4.35,8.75-6.67,14.32-6.36,3.77.21,7.31,1.55,10.17,4.03,3.83,3.34,6.04,8.23,6.03,13.33,0,2.74-.65,5.26-1.69,7.75-1.18,2.84-2.66,5.45-4.32,8.05l-10.62,16.63h0ZM85.37,26.45c3.7-3.68,3.29-9.61-.81-12.76-2.74-2.1-6.43-2.32-9.4-.47-2.39,1.49-3.86,4.1-3.97,6.83-.12,2.84,1.15,5.51,3.43,7.2,3.31,2.45,7.83,2.11,10.76-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.37,26.45c-2.93,2.91-7.44,3.25-10.76.8-2.28-1.68-3.55-4.36-3.43-7.2.11-2.73,1.58-5.34,3.97-6.83,2.97-1.85,6.66-1.63,9.4.47,4.1,3.14,4.51,9.07.81,12.76h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.65,70.13l15.79-7.63,6.91-3.37,3.45-1.75,9.83,6.22c1.02.64,2.02.46,2.84-.42,1.85-1.98,3.6-4.03,5.27-6.17.66-.84,1.46-1.07,2.44-.65l10.81,4.69c.4.17.72.43.79.83.06.3-.12.92-.55,1.09l-22.7,9.2-14.16,5.71c-.98.24-1.82.19-2.73-.24l-17.99-7.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.25,68.37l-12.7-5.05c-.63-.25-1.14-.75-1.15-1.43-.02-.87.6-1.29,1.33-1.61l23.21-10.12c2.73-1.19,5.44-2.19,8.24-3.13,1.75-.58,3.43-.15,4.73,1.17l4.42,6.15-9.99,4.62c-6.13,2.98-12.12,6.08-18.1,9.4h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageLocation);
export default __webpack_public_path__ + "static/media/package-location.2b9b8d694ba91817a158db664e04f03b.svg";
export { ForwardRef as ReactComponent };